import { render, staticRenderFns } from "./merchantRadio.vue?vue&type=template&id=57b97b91&scoped=true"
import script from "./merchantRadio.vue?vue&type=script&lang=js"
export * from "./merchantRadio.vue?vue&type=script&lang=js"
import style0 from "./merchantRadio.vue?vue&type=style&index=0&id=57b97b91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b97b91",
  null
  
)

export default component.exports